import { render, staticRenderFns } from "./token-chart.vue?vue&type=template&id=b884db6a"
import script from "./token-chart.vue?vue&type=script&lang=js"
export * from "./token-chart.vue?vue&type=script&lang=js"
import style0 from "./token-chart.vue?vue&type=style&index=0&id=b884db6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports